// extracted by mini-css-extract-plugin
export default {"mandatory":"MandatoryText_mandatory__-z+ul","mandatoryContainer":"MandatoryText_mandatoryContainer__litxx"};